export enum HttpMethods {
  'CONNECT' = 'CONNECT',
  'DELETE' = 'DELETE',
  'GET' = 'GET',
  'HEAD' = 'HEAD',
  'OPTIONS' = 'OPTIONS',
  'PATCH' = 'PATCH',
  'POST' = 'POST',
  'PUT' = 'PUT',
  'TRACE' = 'TRACE',
}
